const orderAnnotationsWithinTextNodes = (annotations) => {
  // The annotations array will provide an order based on the text nodes in which the annotation starts,
  // but annotations that start in the same text nodes may be out of order.
  // This function will ensure they appear in the correct order within the text node.
  return annotations.sort((a, b) => {
    // if the nodes don't start in the same text node, the order will already be correct.
    if (a.start !== b.start) {
      return 0;
    }

    // If annotations start in the same node, and on the same character, sort by date created.
    if (a.start === b.start && a.startoffset === b.startoffset) {
      const annotationADate = new Date(a.date_created);
      const annotationBDate = new Date(b.date_created);

      return annotationADate.getTime() - annotationBDate.getTime();
    }

    // If the annotations start in the same node and do not start on the same character sort by the startOffset values.
    return a.startoffset - b.startoffset;
  });
};

export default orderAnnotationsWithinTextNodes;
